import "./App.scss";
import "./App.less";
import {useState, useContext, useEffect, useMemo, Suspense} from 'react';
import {Switch, Route}                                      from "react-router-dom";
import {Layout}                                             from 'antd';
import pages                                                from "@page/index.js";
import ws_socket                                            from "@tools/web_socket";
import GlobalNav                                            from "@components/global_navigation/GlobalNav";
import LayoutContext                                        from "@components/contexts/LayoutContext";
import GlobalContext                                        from "@components/contexts/GlobalContext.js";
import LoadingPage                                          from "@components/loading_page/LoadingPage";
import MailingResultInfo                                    from "@components/MailingResultInfo";
import useUserRights                                        from "@hooks/useUserRights";

const { Content } = Layout;

const AppAdmin = (props) => {
    const [compactMenu, setCompactMenu] = useState(true);
    const {checkVisiblePages} = useUserRights();
    const {dispatch} = useContext(GlobalContext);

    const siderNormalWidth = 256;
    const siderCompactWidth = 52;

    let allowPages = checkVisiblePages().filter(it => it.id !== "securityGroup");

    useEffect(() => {
        let socket = ws_socket.on("message", (data) => {
            dispatch({type : "add_socket_event", value: {[data.data._id] : data}});
        });

        return (() => socket.off())
    }, [dispatch]);

    const Home = useMemo(() => pages.home, []);
    const NotFound = useMemo(() => pages.not_found, []);

    return (
        <LayoutContext.Provider value={
            {
                compactMenu,
                setCompactMenu,
                siderNormalWidth,
                siderCompactWidth,
            }
        }>
            <Layout>
                <MailingResultInfo />
                <GlobalNav menus={allowPages} cbLogout={props.cbLogout}/>
                <Layout style={{ marginLeft: compactMenu ? siderCompactWidth : siderNormalWidth }}>
                    <Content>
                        <Suspense fallback={<LoadingPage />}>
                            <Switch>
                                <Route exact path="/">
                                    <Home />
                                </Route>
                                {
                                    allowPages.map(({ url, id }) => {
                                        const Page = pages[ id ] || NotFound;
                                        return (
                                            <Route
                                                path={url}
                                                key={id}
                                            >
                                                <Page id={id}/>
                                            </Route>
                                        )
                                    })
                                }
                                <Route path="*">
                                    <NotFound />
                                </Route>
                            </Switch>

                        </Suspense>
                    </Content>
                </Layout>
            </Layout>
        </LayoutContext.Provider>
    )
};

export default AppAdmin
